import CartActionTypes from "../../actionTypes/cart"
import { getCart } from "../../reducers"
import { getCartItems, updateCart } from "../../../services/cartHelper"

const addAction = (variants, quantity, image, customAttributes = false, setName = false, engravingFont = false) => (dispatch, getState) => {
  if (!variants || !quantity) {
    console.error('Product options and quantity are required');
    return;
  }

  const {checkout, client, isLoading} = getCart(getState());

  if (isLoading === true) {
    return;
  }

  if (!checkout) {
    console.error('A checkout is required');

    return;
  }

  dispatch({
    type: CartActionTypes.ADDING_ACTION
  });

  const isBrowser = typeof window !== 'undefined';
  let items = [];

  if (isBrowser) {
    items = getCartItems();
  }

  const checkoutId = checkout.id;

  let lineItems = [];
  for (let i = 0; i < variants.length; i++) {
    const variantId = variants[i].shopifyId ? variants[i].shopifyId : variants[i].variantId;

    let lineItem = {
        variantId: variantId,
        quantity: parseInt(quantity, 10),
      };

    lineItem.customAttributes = [];

    if (customAttributes) {
      const types = Object.keys(customAttributes);


      types.forEach((customAttributeType) => {
        const customAttribute = customAttributes[customAttributeType];

        lineItem.customAttributes.push(
          {
            key: customAttribute.key,
            value: customAttribute.value
          }
        );
      });
    }

    if (engravingFont) {
      lineItem.customAttributes.push({key: "Font Style", value: engravingFont})
    }

    if (setName) {
      lineItem.customAttributes.push({key: "Set", value: setName})
    }
    lineItems.push(lineItem)
  }

  const lineItemsToUpdate = [...lineItems];
    return client.checkout
      .addLineItems(checkoutId, lineItemsToUpdate)
      .then(checkout => {
        lineItemsToUpdate.forEach((lineItem) => {
          const variantItemId = lineItem.variantId;
          processCartUpdate(dispatch, items, checkout, variantItemId, image);
      })
    });
};

function processCartUpdate(dispatch, items, checkout, variantId, image) {
  let cartData = updateCart(items, checkout, variantId, image)

  //create and parse a deep copy of the cartData to avoid mutation
  let newPayload = JSON.parse(JSON.stringify(cartData))

  dispatch({
    type: CartActionTypes.ADD_ACTION,
    payload: {
      ...newPayload,
      isAdded: true,
      isToggleBasket: true,
    },
  })

  window.setTimeout(function () {
    dispatch({
      type: CartActionTypes.ADDED_ACTION,
      payload: {
        isAdded: false,
        isToggleBasket: false,
      },
    })
  }, 1000)
}

export {
  addAction
}
